import React, { useState, useEffect, Fragment } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import DatePicker from "react-datepicker";
import CreateMeetings from "./CreateMeetings";
import "react-datepicker/dist/react-datepicker.css";
const localizer = momentLocalizer(moment);
import { getAllMeetings } from "../../api/meetings";
import { failed } from "../../utils/Tostify";
import { decryptData } from "../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { getStaffsByOrgId } from "../../api/User";
import { decryptPatientData } from "../../utils/common";
import { getPatients } from "../../api/patient";
import Loader from "../../components/Loader/Loader";
import { useNavigate } from "react-router";
import ViewMeeting from "./ViewMeeting";
import momenttimezone from "moment-timezone";

const Calender = () => {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [events, setEvents] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [teamMembers, setTeamMembers] = useState([]);
  const [patientList, setPatientList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showViewMeeting, setViewMeeting] = useState(false);
  const [isDecline, setIsDecline] = useState(false);
  let token = useSelector(state => state.userReducer.token);
  moment.tz.setDefault();

  const getMeetings = async () => {
  let res;
  try {
    setIsLoading(true);
    const values = {
      orgId: localStorage.getItem("currentOrgId"),
      clinicId: localStorage.getItem("currentHospitalId"),
      isDecline: isDecline
    };
    res = await getAllMeetings({ values, dispatch, token });
    const responseData = decryptData(res?.data);

    if (res?.status === "SUCCESS") {
      const userTimeZone = momenttimezone.tz.guess(); // Get user's timezone dynamically

      const formattedEvents = responseData.map((event) => {
        // Convert stored UTC date and time to user's timezone
        const startDate = momenttimezone.tz(event.fromTime, "UTC").tz(userTimeZone).toDate();
        const endDate = momenttimezone.tz(event.toTime, "UTC").tz(userTimeZone).toDate();

        return {
          id: event._id,
          title: event.eventTitle,
          start: startDate,  // Now in user's timezone
          end: endDate,      // Now in user's timezone
          description: event?.description,
          teamMembers: event?.teamMembers,
          patient: event?.patient,
          eventId: event?._id,
          createdBy: event?.createdBy
        };
      });

      setEvents(formattedEvents);
      setIsLoading(false);
    }else{
      setIsLoading(false);
    }
  } catch (error) {
    failed(res?.message);
    setIsLoading(false);
  }
};

  const getUsersList = async (page = 1, limit = 10, searchKey = "") => {
    let res;
    try {
      res = await getStaffsByOrgId({dispatch, token, page, limit, searchKey, orgId: localStorage.getItem("currentOrgId"), currentHospitalId : localStorage.getItem("currentHospitalId")});
      const responseData = decryptData(res?.data);
      if (res?.status === "SUCCESS") {
        setTeamMembers(
          responseData?.items.filter((item) => item?.active !== false).map((obj) => ({
            label: obj?.firstName + " " + obj?.lastName,
            value: obj?._id
          }))
        );
      }
    } catch (error) {
      failed(res?.message);
    }
  };

  const getPatientList = async () => {
    let res;
    try {
      res = await getPatients({ dispatch, token, listFilter:"all", orgId : localStorage.getItem("currentOrgId"), clinicId : localStorage.getItem("currentHospitalId") });
      if (res?.status === "SUCCESS") {
        const responseData = decryptData(res.data);
        if (responseData?.list) {
          const decryptedPatients = await Promise.all(
            responseData.list.map(async (patient) => {
              return decryptPatientData(patient);
            })
          );
          setPatientList(decryptedPatients.map((obj) => ({
            label: obj?.name?.text,
            value: obj?._id
          })));
        }
      }
    } catch (error) {
      // failed(res?.message);
    }
  };

  useEffect(() => {
    getMeetings();
    getUsersList();
    getPatientList();
  }, []);

  // Sets the selected event when a user clicks on an event
  const handleSelectEvent = (event) => {
    setSelectedEvent(event);
    setViewMeeting(true);
  };

  const handleSelectSlot  = (event) => {
    setSelectedEvent(event);
    setShowOffcanvas(true);
  };

  const handleUserSearch=(e, newInputValue, reason)=>{
    if(reason == "input"){
      getUsersList(1, 10, e.target.value);
    }
  };

  const handleRangechange=(e)=>{
    setSelectedDate(e[0]);
  };

  useEffect(() => {
    if(isDecline){
      getMeetings();
    }
  }, [isDecline]);

  const CustomEvent = ({ event }) => {
    return (
      <div style={{ display: "flex", flexDirection: "column", fontSize: "14px" }}>
        <span>
          {moment(event.start).format("hh:mm A")} - {moment(event.end).format("hh:mm A")}
        </span>
        <strong>{event.title}</strong>
      </div>
    );
  };

  return (
    <Fragment>
    <div className="dashboard_container calender_blkkk">
        {isLoading ? (<Loader/>) : null}
      {/* Header Section */}
      <div className="d-flex justify-content-between align-items-center main-header-block gap-2 p-0">
        <h2 className="home-title">Upcoming Meetings</h2>
        <i className="fa-solid fa-arrow-left" style={{ fontSize: "24px",marginRight:"30px",cursor:"pointer" }}  onClick={()=>navigate("/app/actions/")}></i>
      </div>

      {/* Body Section */}
      <div className="row">
        {/* Sidebar for Scheduling Meetings */}
        <div className="col-xl-4 mb-3">
        <div className="schedule-sidebar">
          <h3>Schedule Meeting</h3>
          <p>Please select date and time for your consultation</p>
          <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            inline
          />
        </div>
        </div>

        {/* Main Calendar */}
        <div className="col-xl-8 mb-3">
        <div className="calendar-container pt-0">
          <div className="btn-container gap-2 flex-wrap m-0 mb-2">
            <button
              className="decline-btn m-0"
              onClick={() => {
                setSelectedEvent(null);
                setShowOffcanvas(false);
                setIsDecline(true);
              }}
            >
              Show Declined Meetings
            </button>
            <button
              className="add-document-btn"
              onClick={() => {
                setSelectedEvent(null);
                setShowOffcanvas(true);
              }}
            >
              Create New Meeting
            </button>
          </div>

          <div className="calendar-container-two">
  <Calendar
    localizer={localizer}
    events={events}
    date={selectedDate}
    selectable
    defaultView="week"
    views={["day", "week", "month"]}
    startAccessor="start"
    endAccessor="end"
    step={30}
    timeslots={1}
    style={{ height: "80vh", margin: "20px 0" }}

    onSelectEvent={handleSelectEvent}
    eventPropGetter={() => {
      if (isDecline === true) {
        return {
          style: { backgroundColor: "red" }
        };
      }
      return {
        style: {
          backgroundColor: "#F4E8E6",
          color: "black",
          borderRadius: "4px",
          fontSize: "15px",
          padding: "4px",
          border: "none"
        }
      };
    }}
    components={{ event: CustomEvent }}
    onSelectSlot={(slotInfo) => {
      handleSelectSlot(slotInfo);
    }}
    onRangeChange={handleRangechange}
  />
</div>

        </div>
        </div>
      </div>

      {/* Offcanvas Component for Adding/Editing Events */}
      {showOffcanvas && (
        <CreateMeetings
          show={showOffcanvas}
          selectedDate={selectedDate}
          isCreate={true}
          onHide={() => setShowOffcanvas(false)}
          patients={patientList}
          getMeetings={getMeetings}
          teamMembers={teamMembers}
          selectedEvent={selectedEvent}
          isLoading={isLoading}
          handleUserSearch={handleUserSearch}
          setIsLoading={setIsLoading}
        />
      )}
      {
        showViewMeeting &&
        (
          <ViewMeeting
            show={showViewMeeting}
            selectedDate={selectedDate}
            onHide={() => setViewMeeting(false)}
            setShowOffcanvas={setShowOffcanvas}
            patients={patientList}
            getMeetings={getMeetings}
            teamMembers={teamMembers}
            selectedEvent={selectedEvent}
            isLoading={isLoading}
            handleUserSearch={handleUserSearch}
            setIsLoading={setIsLoading}
          />
        )
      }
    </div>
    </Fragment>
  );
};

export default Calender;
